/**
 * Whether the teacher schedule should show the "NOT ATTENDED" column.
 * Individual schedules always show it; team schedules do not track attendance.
 */
export function shouldShowNotAttendedColumn(isTeamSchedule: boolean): boolean {
  return !isTeamSchedule;
}
